module.exports = __webpack_public_path__ + "img/sky-banner.c87f58c7.svg";